export const SITE = {
  name: "Sebastian's Produce Inc.",
  shortName: "Sebastian's Produce",
  est: 1968,
  email: "russel@sebastiansproduce.com",
  phone: "949-279-0791",
  phoneHref: "tel:+19492790791",
  address: "2652 East Long Beach Ave, Unit 1",
  city: "Los Angeles, CA 90058",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=2652+East+Long+Beach+Ave+Unit+1+Los+Angeles+CA+90058",
  hours: "Mon – Sat · 4:00 AM – 2:00 PM",
  delivery: "Daily · 4:00 AM – 2:00 PM",
  areas: ["Los Angeles", "Orange County", "Inland Empire"],
};

export const IMG = {
  trucks: "/trucks.webp",
  greenChilies: "/img/green-chilies.jpg",
  basil: "/img/basil.jpg",
  squash: "/img/summer-squash.jpg",
  cucumbers: "https://images.unsplash.com/photo-1604977042946-1eecc30f269e?auto=format&fit=crop&q=80&w=1200",
  heroPeppers: "https://images.unsplash.com/photo-1601648764658-cf37e8c89b70?auto=format&fit=crop&q=80&w=1400",
  pepperPick: "https://images.unsplash.com/photo-1526470498-9ae73c665de8?auto=format&fit=crop&q=80&w=1200",
  tomatoes:
    "https://images.unsplash.com/photo-1692737003338-f2071356a62b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  chilies:
    "https://images.unsplash.com/photo-1567539549213-cc1697632146?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  heirloomSpread:
    "https://images.unsplash.com/photo-1504472685735-9bd4075b3779?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mangoes: "https://images.unsplash.com/photo-1601493700631-2b16ec4b4716?auto=format&fit=crop&q=80&w=1200",
  stillLife: "https://images.unsplash.com/photo-1518843875459-f738682238a6?auto=format&fit=crop&q=80&w=1200",
  redPeppers:
    "https://images.unsplash.com/photo-1614260025937-b4ecb6eb9165?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cayenne:
    "https://images.unsplash.com/photo-1546860255-95536c19724e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  salad: "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&q=80&w=1200",
  vineTomatoes: "https://images.unsplash.com/photo-1592924357228-91a4daadcfea?auto=format&fit=crop&q=80&w=1200",
  bellMix: "https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?auto=format&fit=crop&q=80&w=1200",
  oranges: "https://images.unsplash.com/photo-1547514701-42782101795e?auto=format&fit=crop&q=80&w=1200",
  lemons: "https://images.unsplash.com/photo-1590502593747-42a996133562?auto=format&fit=crop&q=80&w=1200",
  strawberries: "https://images.unsplash.com/photo-1464965911861-746a04b4bca6?auto=format&fit=crop&q=80&w=1200",
  market: "https://images.unsplash.com/photo-1488459716781-31db52582fe9?auto=format&fit=crop&q=80&w=1400",
  avocados: "https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?auto=format&fit=crop&q=80&w=1200",
  pumpkins: "https://images.unsplash.com/photo-1570586437263-ab629fccc818?auto=format&fit=crop&q=80&w=1200",
  watermelon: "https://images.unsplash.com/photo-1587049352846-4a222e784d38?auto=format&fit=crop&q=80&w=1200",
  honeydew: "https://images.unsplash.com/photo-1571575173700-afb9492e6a50?auto=format&fit=crop&q=80&w=1200",
  citrus: "https://images.unsplash.com/photo-1610832958506-aa56368176cf?auto=format&fit=crop&q=80&w=1200",
  fruitMix: "https://images.unsplash.com/photo-1619566636858-adf3ef46400b?auto=format&fit=crop&q=80&w=1200",
};

export const PRODUCTS = [
  {
    id: "peppers",
    name: "Colored Bell Peppers",
    tag: "House specialty",
    color: "var(--red)",
    img: IMG.heroPeppers,
    blurb:
      "Red, yellow, orange and green bells, triple-washed and graded for processing lines and plate-ready kitchens. Bulk bins, cartons or pre-cut to spec.",
    items: ["Red · Yellow · Orange · Green", "Bulk bins & 25 lb cartons", "Diced, sliced or julienne"],
  },
  {
    id: "chilies",
    name: "Mexican Chilies & Hot Peppers",
    tag: "Salsa & sauce grade",
    color: "var(--orange)",
    img: IMG.greenChilies,
    blurb:
      "Jalapeño, serrano, poblano, Anaheim, habanero, pasilla and more — consistent heat, color and size for salsa makers and co-packers.",
    items: ["Jalapeño · Serrano · Poblano", "Anaheim · Habanero · Pasilla", "Fresh, roasted or IQF"],
  },
  {
    id: "cucumbers",
    name: "Cucumbers",
    tag: "Crisp & cold-packed",
    color: "var(--green)",
    img: IMG.cucumbers,
    blurb: "Slicing, Persian and pickling cucumbers, hydro-cooled and graded for salad lines, pickle makers and foodservice.",
    items: ["Slicing · Persian · Pickling", "Bulk bins & cartons", "Sliced, diced or spears"],
  },
  {
    id: "tomatoes",
    name: "Tomatoes",
    tag: "Vine-ripe & processing",
    color: "var(--red)",
    img: IMG.vineTomatoes,
    blurb:
      "Roma, round, heirloom and cherry tomatoes, picked for Brix and firmness. Ideal for salsa, sauces, fresh-cut programs and foodservice.",
    items: ["Roma · Round · Cherry", "Heirloom seasonal", "Diced & crushed to spec"],
  },
  {
    id: "squash",
    name: "Squash & Zucchini",
    tag: "Year-round",
    color: "var(--gold)",
    img: IMG.squash,
    blurb:
      "Zucchini, yellow crookneck, grey and Mexican squash, plus winter varieties — whole, halved, or custom diced for manufacturers.",
    items: ["Zucchini · Yellow · Grey", "Butternut · Kabocha", "Dice, coin or spiral cut"],
  },
  {
    id: "salad",
    name: "Salads & Leafy Greens",
    tag: "Fresh-cut programs",
    color: "var(--green)",
    img: IMG.salad,
    blurb:
      "Romaine, spring mix, spinach, kale and chopped salad blends, washed and packed for high-volume kitchens and meal-prep producers.",
    items: ["Romaine · Spinach · Kale", "Chopped & blended mixes", "Food-safe cold chain"],
  },
  {
    id: "fruits",
    name: "Fresh Fruits",
    tag: "Seasonal",
    color: "var(--orange)",
    img: IMG.citrus,
    blurb:
      "California citrus, berries, melons, avocados and tropicals, sourced direct from growers for purée, juice, bakery and foodservice menus.",
    items: ["Citrus · Berries · Melons", "Avocados · Tropicals", "Purée & juice grade"],
  },
];

export const GALLERY = [
  { src: IMG.heroPeppers, cat: "Peppers", title: "Colored bell peppers", titleEs: "Pimientos de colores", span: "lg" },
  { src: IMG.trucks, cat: "Fleet", title: "Our refrigerated fleet", titleEs: "Nuestra flota refrigerada", span: "lg" },
  { src: IMG.greenChilies, cat: "Chilies", title: "Green jalapeños & serranos", titleEs: "Jalapeños y serranos verdes" },
  { src: IMG.vineTomatoes, cat: "Tomatoes", title: "Vine-ripe tomatoes", titleEs: "Tomates madurados en planta" },
  { src: IMG.squash, cat: "Squash", title: "Summer squash crate", titleEs: "Caja de calabaza de verano", span: "tall" },
  { src: IMG.salad, cat: "Salads", title: "Fresh-cut greens", titleEs: "Hojas verdes de corte fresco" },
  { src: IMG.basil, cat: "Herbs", title: "Fresh basil & cilantro", titleEs: "Albahaca y cilantro frescos", span: "lg" },
  { src: IMG.redPeppers, cat: "Peppers", title: "Red & green bells", titleEs: "Pimientos rojos y verdes" },
  { src: IMG.cucumbers, cat: "Cucumbers", title: "Fresh cucumbers", titleEs: "Pepinos frescos" },
  { src: IMG.chilies, cat: "Chilies", title: "Mixed Mexican chilies", titleEs: "Chiles mexicanos surtidos" },
  { src: IMG.heirloomSpread, cat: "Tomatoes", title: "Heirloom tomatoes", titleEs: "Tomates heirloom" },
  { src: IMG.pepperPick, cat: "Peppers", title: "Hand-picked bells", titleEs: "Pimientos seleccionados a mano", span: "lg" },
  { src: IMG.bellMix, cat: "Peppers", title: "Market bell mix", titleEs: "Mezcla de pimientos" },
  { src: IMG.oranges, cat: "Fruits", title: "California oranges", titleEs: "Naranjas de California" },
  { src: IMG.lemons, cat: "Fruits", title: "Fresh lemons", titleEs: "Limones frescos", span: "tall" },
  { src: IMG.strawberries, cat: "Fruits", title: "Strawberries", titleEs: "Fresas" },
  { src: IMG.avocados, cat: "Fruits", title: "Hass avocados", titleEs: "Aguacates Hass" },
  { src: IMG.watermelon, cat: "Fruits", title: "Watermelon", titleEs: "Sandía" },
  { src: IMG.market, cat: "Salads", title: "Farm-fresh vegetables", titleEs: "Verduras frescas del campo", span: "lg" },
  { src: IMG.honeydew, cat: "Fruits", title: "Mixed melons", titleEs: "Melones surtidos" },
  { src: IMG.mangoes, cat: "Fruits", title: "Ripe mangoes", titleEs: "Mangos maduros" },
  { src: IMG.tomatoes, cat: "Tomatoes", title: "Ripe tomatoes", titleEs: "Tomates maduros" },
  { src: IMG.stillLife, cat: "Salads", title: "Seasonal vegetables", titleEs: "Verduras de temporada" },
  { src: IMG.fruitMix, cat: "Fruits", title: "Seasonal fruit", titleEs: "Fruta de temporada" },
];

export const GALLERY_CATS = ["All", "Peppers", "Chilies", "Cucumbers", "Tomatoes", "Squash", "Herbs", "Salads", "Fruits", "Fleet"];
